import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./lib/auth";
import { Toaster } from "./components/ui/sonner";
import ProtectedRoute from "./components/ProtectedRoute";

import Landing from "./pages/Landing";
import Login from "./pages/Login";

import AdminDashboard from "./pages/admin/Dashboard";
import AdminStudents from "./pages/admin/Students";
import AdminRooms from "./pages/admin/Rooms";
import AdminFees from "./pages/admin/Fees";
import AdminFines from "./pages/admin/Fines";
import AdminNotices from "./pages/admin/Notices";
import AdminTickets from "./pages/admin/Tickets";
import AdminLeaves from "./pages/admin/Leaves";
import AdminVisitors from "./pages/admin/Visitors";

import StudentDashboard from "./pages/student/Dashboard";
import StudentProfile from "./pages/student/Profile";
import StudentFees from "./pages/student/Fees";
import StudentFines from "./pages/student/Fines";
import StudentNotices from "./pages/student/Notices";
import StudentTickets from "./pages/student/Tickets";
import StudentLeaves from "./pages/student/Leaves";
import StudentConsent from "./pages/student/Consent";

function RoleRedirect() {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={user.role === "admin" ? "/admin" : "/student"} replace />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/me" element={<RoleRedirect />} />

            <Route path="/admin" element={<ProtectedRoute role="admin"><AdminDashboard /></ProtectedRoute>} />
            <Route path="/admin/students" element={<ProtectedRoute role="admin"><AdminStudents /></ProtectedRoute>} />
            <Route path="/admin/rooms" element={<ProtectedRoute role="admin"><AdminRooms /></ProtectedRoute>} />
            <Route path="/admin/fees" element={<ProtectedRoute role="admin"><AdminFees /></ProtectedRoute>} />
            <Route path="/admin/fines" element={<ProtectedRoute role="admin"><AdminFines /></ProtectedRoute>} />
            <Route path="/admin/notices" element={<ProtectedRoute role="admin"><AdminNotices /></ProtectedRoute>} />
            <Route path="/admin/tickets" element={<ProtectedRoute role="admin"><AdminTickets /></ProtectedRoute>} />
            <Route path="/admin/leaves" element={<ProtectedRoute role="admin"><AdminLeaves /></ProtectedRoute>} />
            <Route path="/admin/visitors" element={<ProtectedRoute role="admin"><AdminVisitors /></ProtectedRoute>} />

            <Route path="/student" element={<ProtectedRoute role="student"><StudentDashboard /></ProtectedRoute>} />
            <Route path="/student/consent" element={<ProtectedRoute role="student" allowWithoutTnc><StudentConsent /></ProtectedRoute>} />
            <Route path="/student/profile" element={<ProtectedRoute role="student"><StudentProfile /></ProtectedRoute>} />
            <Route path="/student/fees" element={<ProtectedRoute role="student"><StudentFees /></ProtectedRoute>} />
            <Route path="/student/fines" element={<ProtectedRoute role="student"><StudentFines /></ProtectedRoute>} />
            <Route path="/student/notices" element={<ProtectedRoute role="student"><StudentNotices /></ProtectedRoute>} />
            <Route path="/student/tickets" element={<ProtectedRoute role="student"><StudentTickets /></ProtectedRoute>} />
            <Route path="/student/leaves" element={<ProtectedRoute role="student"><StudentLeaves /></ProtectedRoute>} />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster richColors position="top-right" />
      </AuthProvider>
    </div>
  );
}

export default App;
